// CORE-bar curation control (§46.1 P3, §46.3 d6) — SINGLE-select v1: the lens
// is either unfiltered or scoped to ONE of the user's reaction fields
// (feed.py:2225 like/dislike/catalog). Not a SourceSelector: four fixed,
// mutually exclusive states are a segmented group, the bar's other
// single-choice idiom (TrendingLensRow's mode switch — same shell, same
// active treatment).
//
// Compactness rule: the bar is ONE row and every control's width must be
// STABLE — the active state spelling its word (as it once did) resized the
// group on every click and shifted the whole bar. The icon states are
// icon-only in every state (active is the fill/color treatment alone), with
// title/aria carrying the words. "All" always shows its word — it has no
// icon, and a group of four bare glyphs reads as a toolbar, not as a choice.
//
// VOCABULARY: display says "Catalogued", the wire says "cataloged" (server
// vocabulary, feed.py). The value never leaves this file untranslated.
import React, { memo } from "react";
import { Bookmark, ThumbsDown, ThumbsUp } from "lucide-react";

const OPTIONS = [
  [null, "All", null, "Every document in the window"],
  ["liked", "Liked", ThumbsUp, "Only documents you liked"],
  ["disliked", "Disliked", ThumbsDown, "Only documents you disliked"],
  ["cataloged", "Catalogued", Bookmark, "Only documents you catalogued"],
];

const CurationSelector = memo(({ value = null, onChange }) => {
  const active = value || null;
  return (
    <div
      className="inline-flex h-8 shrink-0 items-center rounded-lg border border-mainDivider bg-mainButtonBg/35 p-0.5"
      role="group"
      aria-label="Curation"
    >
      {OPTIONS.map(([key, label, Icon, title]) => {
        const on = active === key;
        return (
          <button
            key={key || "all"}
            type="button"
            title={title}
            aria-label={label}
            aria-pressed={on}
            onClick={() => onChange?.(key)}
            className={`inline-flex items-center gap-1 rounded-md px-2 py-1 text-[11px] transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-inputFocus/60 ${
              on
                ? "bg-velBlue/20 text-velBlue"
                : "text-mutedText hover:bg-mainButtonBg/60 hover:text-mainText"
            }`}
          >
            {Icon ? <Icon size={12} /> : <span>{label}</span>}
          </button>
        );
      })}
    </div>
  );
});

CurationSelector.displayName = "CurationSelector";

export default CurationSelector;
